import axios from "axios";

const instance = ( baseUrl ) => axios.create({
    baseURL: String(baseUrl),
});

export default instance;